import React from 'react';
import { Link } from 'react-router-dom';
export const Error500: React.FC = () => {
    return (
        <div className="absolute inset-0">
            <div className="flex flex-col flex-1 items-center justify-center h-full px-6 py-10">
                {/* You can add a 500-specific illustration here */}
                <div className="mt-12 md:mt-24 text-4xl md:text-7xl font-extrabold -tracking-tight leading-tight md:leading-none text-center">500 - Server Error</div>
                <div className="mt-2 text-lg md:text-xl font-medium -tracking-tight text-center text-gray-500">Something went wrong on our end. Please try again later.</div>
                <Link to="/dashboard" className="mt-12 font-medium underline text-blue-500">Back to Dashboard</Link>
            </div>
        </div>
    );
};
